import React from 'react'


const Info = props => (
	<svg {...props}>
		<path d="M8,0 C3.6,0 0,3.6 0,8 C0,12.4 3.6,16 8,16 C12.4,16 16,12.4 16,8 C16,3.6 12.4,0 8,0 Z M8.8,12 L7.2,12 L7.2,7.2 L8.8,7.2 L8.8,12 Z M8.8,5.6 L7.2,5.6 L7.2,4 L8.8,4 L8.8,5.6 Z" />
	</svg>
)

export default Info
